

export default {
  locale: 'by',
  Pagination: {
    items_per_page: '/старонка',
    jump_to: 'Перайсці',
    jump_to_confirm: 'Пацвердзіць',
    page: '',
    prev_page: 'Назад',
    next_page: 'Наперад',
    prev_5: 'Папярэднія 5',
    next_5: 'Наступныя 5',
    prev_3: 'Папярэднія 3',
    next_3: 'Наступныя 3',
    page_size: 'памер старонкі'
  },
  DatePicker: {
    lang: {
      placeholder: 'Выберыце дату',
      yearPlaceholder: 'Выберыце год',
      quarterPlaceholder: 'Выберыце квартал',
      monthPlaceholder: 'Выберыце месяц',
      weekPlaceholder: 'Выберыце тыдзень',
      rangePlaceholder: ['Пачатковая дата', 'Канчатковая дата'],
      rangeYearPlaceholder: ['Пачатковы год', 'Год заканчэння'],
      rangeMonthPlaceholder: ['Пачатковы месяц', 'Канчатковы месяц'],
      rangeWeekPlaceholder: ['Пачатковы тыдзень', 'Канчатковы тыдзень'],
      locale: 'by_BY',
      today: 'Сёння',
      now: 'Зараз',
      backToToday: 'Дадзеная дата',
      ok: 'Ok',
      clear: 'Ачысціць',
      month: 'Месяц',
      year: 'Год',
      timeSelect: 'Выбраць час',
      dateSelect: 'Выбраць дату',
      weekSelect: 'Выбраць тыдзень',
      monthSelect: 'Выбраць месяц',
      yearSelect: 'Выбраць год',
      decadeSelect: 'Выбраць дзесяцігоддзе',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Папярэдні месяц (PageUp)',
      nextMonth: 'Наступны месяц (PageDown)',
      previousYear: 'Папярэдні год (Control + left)',
      nextYear: 'Наступны год (Control + right)',
      previousDecade: 'Папярэдняе дзесяцігоддзе',
      nextDecade: 'Наступнае дзесяцігоддзе',
      previousCentury: 'Папярэдні век',
      nextCentury: 'Наступны век'
    },
    timePickerLocale: {
      placeholder: 'Выберыце час',
      rangePlaceholder: ['Час пачатку', 'Час заканчэння']
    }
  },
  TimePicker: {
    placeholder: 'Выберыце час',
    rangePlaceholder: ['Час пачатку', 'Час заканчэння']
  },
  Calendar: {
    lang: {
      placeholder: 'Выберыце дату',
      yearPlaceholder: 'Выберыце год',
      quarterPlaceholder: 'Выберыце квартал',
      monthPlaceholder: 'Выберыце месяц',
      weekPlaceholder: 'Выберыце тыдзень',
      rangePlaceholder: ['Пачатковая дата', 'Канчатковая дата'],
      rangeYearPlaceholder: ['Пачатковы год', 'Год заканчэння'],
      rangeMonthPlaceholder: ['Пачатковы месяц', 'Канчатковы месяц'],
      rangeWeekPlaceholder: ['Пачатковы тыдзень', 'Канчатковы тыдзень'],
      locale: 'by_BY',
      today: 'Сёння',
      now: 'Зараз',
      backToToday: 'Дадзеная дата',
      ok: 'Ok',
      clear: 'Ачысціць',
      month: 'Месяц',
      year: 'Год',
      timeSelect: 'Выбраць час',
      dateSelect: 'Выбраць дату',
      weekSelect: 'Выбраць тыдзень',
      monthSelect: 'Выбраць месяц',
      yearSelect: 'Выбраць год',
      decadeSelect: 'Выбраць дзесяцігоддзе',
      yearFormat: 'YYYY',
      dateFormat: 'D-M-YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D-M-YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Папярэдні месяц (PageUp)',
      nextMonth: 'Наступны месяц (PageDown)',
      previousYear: 'Папярэдні год (Control + left)',
      nextYear: 'Наступны год (Control + right)',
      previousDecade: 'Папярэдняе дзесяцігоддзе',
      nextDecade: 'Наступнае дзесяцігоддзе',
      previousCentury: 'Папярэдні век',
      nextCentury: 'Наступны век'
    },
    timePickerLocale: {
      placeholder: 'Выберыце час',
      rangePlaceholder: ['Час пачатку', 'Час заканчэння']
    }
  },
  global: {
    placeholder: 'Калі ласка выберыце'
  },
  Table: {
    filterTitle: 'Фільтр',
    filterConfirm: 'OK',
    filterReset: 'Скінуць',
    filterEmptyText: 'Без фільтраў',
    emptyText: 'Няма дадзеных',
    selectAll: 'Выбраць усе',
    selectInvert: 'Інвертаваць выбар',
    selectionAll: 'Выбраць усе дадзеныя',
    sortTitle: 'Сартаванне',
    expand: 'Разгарнуць радок',
    collapse: 'Згарнуць радок',
    triggerDesc: 'Націсніце для сартавання па змяншэнні',
    triggerAsc: 'Націсніце для сартавання па ўзросту',
    cancelSort: 'Націсніце, каб адмяніць сартаванне'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Адмена',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Адмена'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Пошук',
    itemUnit: 'элем.',
    itemsUnit: 'элем.',
    remove: 'Выдаліць',
    selectAll: 'Выбраць усе дадзеныя',
    selectCurrent: 'Вылучыць дадзеную старонку',
    selectInvert: 'Паказаць у зваротным парадку',
    removeAll: 'Выдаліць усе дадзеныя',
    removeCurrent: 'Выдаліць дадзеную старонку'
  },
  Upload: {
    uploading: 'Загрузка...',
    removeFile: 'Выдаліць файл',
    uploadError: 'Адбылася памылка пры загрузцы',
    previewFile: 'Прадпрагляд файла',
    downloadFile: 'Загрузіць файл'
  },
  Empty: {
    description: 'Няма дадзеных'
  },
  Icon: {
    icon: 'Іконка'
  },
  Text: {
    edit: 'Рэдагаваць',
    copy: 'Капіяваць',
    copied: 'Капіяванне завершана',
    expand: 'Разгарнуць'
  },
  PageHeader: {
    back: 'Назад'
  }
};
